export type SprintStatus = 'STANDBY' | 'INPROGRESS' | 'FINISHED' | 'CANCELED'

export const isValidSprint = (status: SprintStatus): boolean => {
  return status === 'STANDBY' || status === 'INPROGRESS'
}
export const isClosedSprint = (status: SprintStatus): boolean => {
  return status === 'FINISHED' || status === 'CANCELED'
}
